export { default as RatingOneIcon } from './One'
export { default as RatingTwoIcon } from './Two'
export { default as RatingThreeIcon } from './Three'
export { default as RatingFourIcon } from './Four'
export { default as RatingFiveIcon } from './Five'
